<template>
	<div style="display: inline-block;">
		<input v-show="false" ref="inputFile" type="file" @change="importExcel" />
        <el-button @click="onDerive" icon="el-icon-upload2" type="warning">Import</el-button>
	</div>
</template>

<script>
	export default {
		props: {
			fileType: {
				type: String,
				default: '',
			},
			fileName: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				contentData: [],
			}
		},
		methods: {
			onDerive() {
				this.$refs.inputFile.click()
			},
			// 导入
			importExcel(file) {
				// 获取上传excel文件的信息
				const fileContent = file.target.files[0]
				// 获取文件类型
				// const types = file.name.split('.')[1]
				// const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt'].some(
				//   (item) => item === types
				// )
				// if (!fileContent) {
				//   if (!fileType) {
				//     alert('格式错误！请重新选择')
				//     return
				//   }
				// }
				this.importFile(fileContent)
			},
			// 文件数据的处理
			importFile(obj) {
				// 文件读取
				const reader = new FileReader()
				const _this = this
				// 按字节读取文件内容，结果用ArrayBuffer对象表示
				reader.readAsArrayBuffer(obj)
				//  读取操作完成时触发的事件(reader.onload)
				reader.onload = function () {
					const buffer = reader.result
					// Uint8Array 数组类型转化为16进制字符串
					const bytes = new Uint8Array(buffer)
					const length = bytes.byteLength
					let binary = ''
					for (let i = 0; i < length; i++) {
						// 转码
						binary += String.fromCharCode(bytes[i])
					}
					const XLSX = require('xlsx')
					// 获取excel表格中的表头
					const wb = XLSX.read(binary, {
						type: 'binary',
					})
					const outData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
					const data = [...outData]
					// 定义转化完成的数据
					const arr = []
					// 将每一项的数据进行转化
					if(_this.fileName == 'applicationFile'){
						data.map((v,index) => {
							if(index > 0){
								let obj = {
									registrationNo: v['[registration_no]'],
									applicationStage: v['[stage]'],
								}
								arr.push(obj)
							}
						})
					}else{
						data.map((v) => {
							let obj = {
								registrationNo: v['Registration No.'],
								interviewTime:  v['Interview-1-Datetime (Format: mm/dd/yy h:mm:ss)'] ? _this.setInterviewTime(v['Interview-1-Datetime (Format: mm/dd/yy h:mm:ss)'])  : '',
								interviewLocation: v['Interview-1-location'],
								interviewTime2: v['Interview-2-Datetime (Format: mm/dd/yy h:mm:ss)'] ? _this.setInterviewTime(v['Interview-2-Datetime (Format: mm/dd/yy h:mm:ss)'])  : '',
								interviewLocation2: v['Interview-2-location'],
								reportLocation: v['Report Location'],
							}
							arr.push(obj)
						})
					}
					_this.contentData = arr
					_this.$emit('importExcel', _this.contentData)
					_this.$refs.inputFile.value = null
				}
			},
			setFormatDate (numb, format) {
				let time = new Date((numb - 3) * 24 * 3600000 + 1)
				time.setYear(time.getFullYear() - 70)
				let year = time.getFullYear() + ''
				let month = time.getMonth() + 1 + ''
				let date = time.getDate() + ''
				if(format && format.length === 1) {
					return year + format + month + format + date
				}
				return year+(month < 10 ? '0' + month : month)+(date < 10 ? '0' + date : date)
			},
			setSecondsToTime(seconds) {
				// 将秒转换为小时、分钟和剩余的秒
				const hours = Math.floor(seconds / 3600);
				const minutes = Math.floor((seconds % 3600) / 60);
				const secs = seconds % 60;
				// 使用padStart确保每个部分至少有两位数
				// 例如，将5转换为'05'
				const hoursStr = String(hours).padStart(2, '0');
				const minutesStr = String(minutes).padStart(2, '0');
				const secsStr = String(secs).padStart(2, '0');
				// 返回格式化的时间字符串
				return `${hoursStr}:${minutesStr}:${secsStr}`;
			},
			setFormatTime(numb){
				var second = numb - Math.floor(numb);
				var secondTrue = Math.round(24 * 60*60*second);
				return this.setSecondsToTime(secondTrue)
			},
			setInterviewTime(numb){
				return this.setFormatDate(numb, '/') + ' ' + this.setFormatTime(numb)
			}

		},
	}
</script>

<style lang="scss" scoped>
	.aa {
		display: inline-block;
	}
	.cursor {
		width: 20px;
		height: 20px;
		margin-right: 30px;
		border-left: 1px solid #aaa;
		border-right: 1px solid #fff;
	}
</style>
